import React from 'react'
import './sign-request-by-volume-resume.view.css'
import { useTranslation } from 'react-i18next'
import { ButtonHLPure } from '../../pures'
import { Label } from '@progress/kendo-react-labels'
import { Grid } from '@material-ui/core'
import { DialogSystemGLPure } from '../../pures'

const SignRequestByVolumeResume = (props) => {
  const { t } = useTranslation()
  const {
    step,
    onHandleBack,
    onSendToSign,
    requestName,
    comments,
    description,
    csvJson,
    limitDate,
  } = props
  const { send, back } = step

  const formatDate = (date) => {
    let day = date.getDate()
    let month = date.toLocaleString('default', { month: 'short' })
    let year = date.getFullYear()

    if (month < 10) {
      return `${day}/0${month}/${year}`
    } else {
      return `${day}/${month}/${year}`
    }
  }

  const limitDateFormatted = formatDate(limitDate)

  const pscStyles = (() => {
    let stylesClass = ''
    if (props.serviceCMChecked && !props.serviceSTChecked) stylesClass = 'value-serviceConservation-alone'
    if (!props.serviceCMChecked && props.serviceSTChecked) stylesClass = 'value-serviceStamp'
    if (!props.serviceCMChecked && !props.serviceSTChecked) stylesClass = 'value-ninguno'
    if (props.serviceCMChecked && props.serviceSTChecked) stylesClass = 'value-serviceConservation-both'

    return stylesClass
  })()

  return (
    <div className='card-description-reliable'>
      <div className='signRequest-container'>
        <div className='signRequest-labels'>
          <Label className='label-title-name-request'>
            {t('signRequestByVolume.requestName')}:
          </Label>
          <Label className='value-name'>{requestName}</Label>
        </div>
        <div className='signRequest-labels'>
          <Label className='label-title'>
            {t('signRequestByVolume.notesForSigners')}:
          </Label>
          <Label className='value-notes'>{comments}</Label>
        </div>
      </div>

      <Grid item lg={12} md={12} sm={12} xs={12}>
        <hr className='line-section' />
      </Grid>
      <div className='signRequest-container'>
        <div className='signRequest-labels'>
          <Label className='label-middle-title'>
            {t('signRequestByVolume.amountOfDocuments')}:
          </Label>
          <Label className='value-documents'>
            {csvJson.length} {t('signRequestByVolumeResume.documents')}
          </Label>
        </div>
        <div className='signRequest-labels'>
          <Label className='label-title'>
            {t('signRequestByVolume.finalDateForSigns')}:{' '}
          </Label>
          <Label className='value-date'>
            {limitDateFormatted}
          </Label>
        </div>
        <div className='signRequest-labels'>
          <Label className='label-title-services'>
            {t('signRequestByVolume.pscServices')}:
          </Label>
          <Label className={pscStyles}>
            {(props.serviceSTChecked && !props.serviceCMChecked) && t('signRequestByVolume.serviceTimeStamp')}
            {(props.serviceCMChecked && !props.serviceSTChecked) && t('signRequestByVolume.serviceConservation')}
            {!props.serviceCMChecked && !props.serviceSTChecked && t('signRequestByVolumeResume.nothing')}
            {props.serviceCMChecked && props.serviceSTChecked &&
              <>
                {t('signRequestByVolume.serviceTimeStamp')}
                {t('signRequestByVolume.and')}
                {t('signRequestByVolume.serviceConservation')}
              </>
            }
          </Label>
        </div>
        <div className='signRequest-labels'>
          <Label className='label-title'>
            {t('signRequestByVolume.signType')}
          </Label>
          <Label className='value-signType'>
            {props.signatureTypeESignChecked && t('signRequestByVolume.eSign')}
            {props.signatureTypeAutographChecked && t('signRequestByVolume.autograph')}
            {props.signatureTypeAdvancedChecked && t('signRequestByVolume.advanced')}
          </Label>
        </div>
        <div className='signRequest-labels'>
          <Label className='label-title'>
            {t('signRequestByVolume.signFlow')}:
          </Label>
          <Label className='value-processType'>
            {props.processTypeRandomChecked && t('signRequestByVolume.random')}
            {props.processTypeSequentialChecked && t('signRequestByVolume.sequential')}
            {props.processTypeAprovationChecked && t('signRequestByVolume.approbation')}
            {props.processTypeAprovationSequentialChecked && t('signRequestByVolume.sequentialApprobation')}
          </Label>
        </div>
      </div>
      <Grid item lg={12} md={12} sm={12} xs={12}>
        <hr className='line-section' />
      </Grid>
      <div className='signRequestByVolumeResume-container-btns'>
        <ButtonHLPure
          nameBtn={back}
          primary={false}
          onClickBtn={(event) => onHandleBack(event)}
        />
        <ButtonHLPure
          nameBtn={send}
          primary={true}
          onClickBtn={() => {
            onSendToSign()
          }}
        />
      </div>
      <DialogSystemGLPure
        {...props}
        toggleLoadingRequesting={props.toggleLoadingRequesting}
        toggleCompletedRequesting={props.toggleCompletedRequesting}
        toggleErrorRequesting={props.toggleErrorRequesting}
        toggleErrorDomain={props.toggleErrorDomain}
        cancel={props.cancel}
        handleSubmitConfirm={props.handleSubmitConfirm}
      />
    </div>
  )
}

export default SignRequestByVolumeResume
